/* DTF Gears – Printheads collection */
(function () {
  'use strict';
  if (window.DTFGPrintheadsPage) return;

  var COMPAT_RE = /compatib|models include|supported/i;

  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  /* Printer models listed in a product description */
  function getModels(root) {
    var models = [];
    root.querySelectorAll('ul').forEach(function (ul) {
      var prev = ul.previousElementSibling;
      if (prev && COMPAT_RE.test(prev.textContent)) {
        ul.querySelectorAll('li').forEach(function (li) {
          var t = li.textContent.trim();
          if (t && !/^other\b/i.test(t)) models.push(t);
        });
      }
    });
    if (!models.length) {
      root.querySelectorAll('tr').forEach(function (tr) {
        var c = tr.children;
        if (c.length > 1 && /compatib/i.test(c[0].textContent)) {
          c[1].textContent.split(/[,;]/).forEach(function (t) { t = t.trim(); if (t) models.push(t); });
        }
      });
      root.querySelectorAll('p').forEach(function (p) {
        var s = p.querySelector('strong');
        if (s && /compatible printer/i.test(s.textContent)) {
          var t = p.textContent.replace(s.textContent, '').trim();
          if (t) models.push(t);
        }
      });
    }
    return models;
  }

  /* Up to 3 spec rows from the description's spec table */
  function getSpecs(root, labelsCsv) {
    var rows = [];
    root.querySelectorAll('tr').forEach(function (tr) {
      var c = tr.querySelectorAll('td');
      if (c.length > 1) rows.push([c[0].textContent.trim(), c[1].textContent.trim()]);
    });
    var out = [];
    (labelsCsv || '').split(',').forEach(function (label) {
      if (out.length >= 3) return;
      var key = norm(label);
      if (!key) return;
      for (var i = 0; i < rows.length; i++) {
        if (norm(rows[i][0]) === key) { out.push(rows[i]); break; }
      }
    });
    return out;
  }

  function initRow(row, labels) {
    var tpl = row.querySelector('template[data-desc]');
    var desc = document.createElement('div');
    desc.innerHTML = tpl ? tpl.innerHTML : '';

    /* Specs */
    var specsEl = row.querySelector('[data-specs]');
    var specs = getSpecs(desc, labels);
    if (specsEl && specs.length) {
      specsEl.innerHTML = specs.map(function (r) {
        return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>';
      }).join('');
      specsEl.hidden = false;
    }

    /* Fits line */
    var fitsEl = row.querySelector('[data-fits]');
    var fitsText = row.querySelector('[data-fits-text]');
    var models = getModels(desc);
    if (fitsEl && fitsText && models.length) {
      if (models.length === 1) {
        fitsText.innerHTML = 'Fits <strong>' + esc(models[0]) + '</strong>';
      } else if (models.length <= 2) {
        fitsText.innerHTML = 'Fits <strong>' + models.map(esc).join(', ') + '</strong>';
      } else {
        fitsText.innerHTML = 'Fits <strong>' + esc(models[0]) + '</strong> and ' + (models.length - 1) + ' more printers';
      }
      fitsEl.hidden = false;
    }

    /* Variant select */
    var select = row.querySelector('[data-variant-select]');
    var priceEl = row.querySelector('[data-price]');
    var skuEl = row.querySelector('[data-sku]');
    var atc = row.querySelector('[data-atc]');
    if (select) {
      select.addEventListener('change', function () {
        var o = select.options[select.selectedIndex];
        if (!o) return;
        if (priceEl) priceEl.textContent = o.dataset.price;
        if (skuEl) { skuEl.textContent = o.dataset.sku || ''; skuEl.parentElement.hidden = !o.dataset.sku; }
        var ok = o.dataset.available === 'true';
        if (atc) { atc.disabled = !ok; atc.textContent = ok ? 'Add to cart' : 'Sold out'; }
      });
    }

    /* Quantity */
    var qty = row.querySelector('[data-qty-input]');
    row.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });
  }

  function initList(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';

    var labels = sec.dataset.specLabels || '';
    var rows = sec.querySelectorAll('[data-row]');
    rows.forEach(function (r) { initRow(r, labels); });

    var btns = sec.querySelectorAll('[data-filter]');
    var count = sec.querySelector('[data-count]');
    var empty = sec.querySelector('[data-empty]');
    var reset = sec.querySelector('[data-filter-reset]');

    function apply(tag) {
      var shown = 0;
      rows.forEach(function (r) {
        var ok = !tag || (r.dataset.tags || '').indexOf('|' + tag + '|') > -1;
        r.hidden = !ok;
        if (ok) shown++;
      });
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.filter === tag ? 'true' : 'false'); });
      if (count) count.textContent = shown + (shown === 1 ? ' printhead' : ' printheads');
      if (empty) empty.hidden = shown > 0;
    }

    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.filter); }); });

    var sort = sec.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    if (reset) reset.addEventListener('click', function () { apply(''); });
    apply('');
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-phl-list]').forEach(initList);
  }

  window.DTFGPrintheadsPage = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();